import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { Box } from "../../../components/Box";
import { Button } from "../../../components/Button";
import { Flex } from "../../../components/Flex";
import { H2 } from "../../../components/Heading";
import { Paragraph } from "../../../components/Paragraph";
import { Input } from "../../../components/Input";
import { NewProfileApplicationFrame } from "./NewProfileApplicationFrame";
import { ROUTE } from "../../../routes";

const schema = Yup.object().shape({
  contactEmail: Yup.string()
    .trim()
    .email("Please enter a valid email address.")
    .required("Email address is required."),
});

export const AddContactStep = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const profileId = Number(id);
  const { profile } = useOutletContext<any>();
  const isEntity = profile?._type === "entity";

  const location = useLocation();

  const prevState: any = location.state ?? {};

  const title = isEntity ? "Add Contact" : "Confirm Email";

  const description = isEntity
    ? "Please add the entity contact's email address. This is the person you would like to provide information on this entity. "
    : "Please confirm the email address for the invite for this application. ";

  const onNext = (values: any) => {
    const contactEmail = values.contactEmail.trim();

    navigate(
      ROUTE.PROFILE_APPLICATION_SEND_INVITES.replace(
        ":id",
        profileId.toString(),
      ),
      {
        state: {
          ...prevState,
          contactEmail,
        },
      },
    );
  };

  return (
    <NewProfileApplicationFrame step="addContact">
      <Box mt={2}>
        <H2>{title}</H2>
        <Paragraph>{description}</Paragraph>

        <Formik
          initialValues={{
            contactEmail: prevState.contactEmail ?? "",
          }}
          validationSchema={schema}
          onSubmit={onNext}
          validateOnMount
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Box mt={3}>
                <Input
                  label="Email address"
                  placeholder="Enter email address"
                  name="contactEmail"
                  value={props.values.contactEmail}
                  onChange={props.handleChange}
                  isRequired
                  hasError={Boolean(
                    props.touched.contactEmail && props.errors.contactEmail,
                  )}
                  errorMessage={
                    (props.touched.contactEmail &&
                      props.errors.contactEmail) as any
                  }
                />
              </Box>

              <Flex justifyContent="space-between" mt={3}>
                <Button
                  variant="text"
                  type="button"
                  onClick={() =>
                    navigate(
                      ROUTE.PROFILE_APPLICATION_APPLICATION_TYPE.replace(
                        ":id",
                        profileId.toString(),
                      ),
                      { state: prevState },
                    )
                  }
                >
                  Back
                </Button>

                <Button type="submit" isDisabled={!props.isValid}>
                  Next
                </Button>
              </Flex>
            </Form>
          )}
        </Formik>
      </Box>
    </NewProfileApplicationFrame>
  );
};
